import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { reduxConnect } from '../../../../common';

import { TaboolaFeedWidget } from '../../../ads/taboolaFeedWidget.jsx';

const mapStoreStateToProps = (storeState, ownProps) => {
    const appState = storeState?.appState?.appState || {};
    const { enableTaboola } = appState;

    return { isEnabled: enableTaboola };
};

const mapDispatchToProps = {};

export const WidgetTaboolaAd = reduxConnect(mapStoreStateToProps, mapDispatchToProps)
(({ position='mid_article', width=300, height=250, isEnabled = false }) => {
    if (position && isEnabled) {
        return (
            <TaboolaContentWrapper>
                <TaboolaFeedWidget width={width} height={height}  position={position} />
            </TaboolaContentWrapper>
        );
    } else {
        return null;
    }
});

WidgetTaboolaAd.displayName = 'WidgetTaboolaAd';

WidgetTaboolaAd.propTypes = {
    position: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    isEnabled: PropTypes.bool
};

const TaboolaContentWrapper = styled.section`
    width: 100%;
    height: auto;
    margin-top: 12px;
    margin-bottom: 12px;
`;

